module.exports = __webpack_public_path__ + "static/deliverImage-3517714fb315bbabc9be69d88ba8cd6f.png";